import { mergeStyles, Stack } from '@fluentui/react';

import logo from '../../assets/logo.png';
import CommandBar from './command-bar';
import Persona from './persona';

export default () => {
  return (
    <div className={`${navbarStyle} no-print`}>
      <div className={navbarContainerStyle}>
        <Stack horizontal verticalAlign="center">
          <Stack style={{ padding: "4px" }}>
            <img src={logo} height="34px" />
          </Stack>
          <Stack.Item grow>
            <CommandBar />
          </Stack.Item>
          <Stack.Item>
            <Persona />
          </Stack.Item>
        </Stack>
      </div>
    </div>
  );
};

const navbarContainerStyle = mergeStyles({ padding: "4px 32px" });

const navbarStyle = mergeStyles({
  // boxShadow: theme.effects.elevation8,
  backgroundColor: "white",
  width: "100%",
  // "& *": {
  //   backgroundColor: `${theme.palette.themeLighterAlt} !important`,
  // },
});
